'use strict';

$(function(){
	const breakpoint = 768;

	// loading
	// web font loding 後にbodyを描画する
	$(window).on('load', function(){
		$('.carousel').delay(1000).removeClass('s-hidden');
	});
	function carouselClose() {
		$('.carousel').removeClass('s-hidden');
		// $('html').addClass('s-visible');
	}
	setTimeout(carouselClose, 2000);

	// home slide
	if($('.js-slide').length) {
		$('.js-slide').slick({
			centerPadding: '0px',
			centerMode: true,
			centerPadding:'25%',
			slidesToShow: 1,
			autoplay: true,
			autoplaySpeed: 4000,
			dots: false,
			easing: 'linear',
			waitForAnimate: false,
			arrows: true,
			infinite: true,
			focusOnSelect: true,
			fade: false,
			// rtl: true,
			responsive: [
			{
				breakpoint: breakpoint,
				settings: {
					centerMode: true,
					centerPadding: '20px',
					slidesToShow: 1
				}
			}]
		});
	}
	// 選んだ大学をcookieへ保存
	$('.js-choose-univ').on('click', function(){
		$.cookie('univ', $(this).attr('href'), { expires: 540});
	});

	// (function(){
	// 	let isPageTopBtn = false;
	// 	let $pagetopbutton = $('.js-btnpagetop');
	// 	$pagetopbutton.hide();
	// 	$(window).scroll(function(){
	// 		if(!isPageTopBtn && $(this).scrollTop() > 200) {
	// 			$pagetopbutton.fadeIn(500);
	// 			isPageTopBtn = true;
	// 		} else if(isPageTopBtn && $(this).scrollTop() <= 200) {
	// 			$pagetopbutton.fadeOut(1000);
	// 			isPageTopBtn = false;
	// 		}
	// 	});
	// }());

	(function(){
		let scroll = new SmoothScroll('a[href*="#"]', {
			header: '#head',
			speed: 300
		});
	}());

	// if($('.js-fadeinlogo').length) {
	// 	$('.js-fadeinlogo').waypoint(function(direction) {
	// 		var activePoint = $(this.element);
	// 		if(direction === 'down') {
	// 			activePoint.addClass('s-active');
	// 		} else {
	// 		}
	// 	},{offset: '70%'});
	// }

	// サークルの雰囲気アイコンのdelayアニメ
	if($('.js-fadein').length) {
		$('.js-fadein').waypoint(function(direction) {
			var activePoint = $(this.element);
			if(direction === 'down') {
				activePoint.addClass('s-show');
			} else {
			}
		},{offset: '75%'});
	}

	if($('.js-scroll_to_bottom').length) {
		$('.js-scroll_to_bottom_cont').waypoint(function(direction) {
			// var activePoint = $(this.element);
			if(direction === 'down') {
				$('.js-scroll_to_bottom').addClass('s-hidden');
			} else {
			}
		},{offset: '54px'});
	}

	// const displayTime = 24 * 7 * 60; // new icon の表示時間

	// // New アイコン表示制御
	// // publishDate => YYYY:MM:DD:hh:mm:ss
	// function displayNewIcon(publishDate){
	// 	let icon;
	// 	let currentDate = new Date();
	// 	let time = publishDate.split(':');
	// 	let entryDate = new Date(time[0], time[1] - 1, time[2], time[3], time[4], time[5]);
	// 	let entryTime = (entryDate.getTime());
	// 	let diff = currentDate.getTime() - entryDate.getTime();
	// 	let diffMin = Math.floor(diff / (1000 * 60)); // 差分をミリ秒から分へ変換し、端数切り捨て
	// 	if(diffMin < displayTime) {
	// 		icon = '<i class="newicon">New</i>';
	// 	} else {
	// 		icon = '';
	// 	}
	// 	return icon;
	// };

	// // #付きでランディングした時にヘッダー分下げる
	// (function(){
	// 	const menuH = $('.l-header').height();

	// 	let urlhash = window.location.hash;
	// 	// alert(urlhash);
	// 	// alert(menuH);
	// 	let dist; //スクロールする位置

	// 	let setPageDist = (hash) => {

	// 		dist = $(hash).offset().top - menuH;
	// 		// console.log(dist);
	// 		$('html, body').animate({
	// 			scrollTop: dist
	// 		}, 250);
	// 		return false;
	// 	}

	// 	// 描画を遅延
	// 	var timer = false;
	// 	let lazyload = () => {
	// 		if (timer !== false) {
	// 			clearTimeout(timer);
	// 		}
	// 		timer = setTimeout(() => {
	// 			setPageDist(urlhash);
	// 		}, 50);
	// 	}

	// 	if(urlhash) {
	// 		lazyload();
	// 	}
	// }());

	// search toggle button
	$('.js-togglebtn').each(function() {
		$(this).on('click', function() {
			$(this).next().slideToggle();
			$(this).toggleClass('on');
			return false;
		});
	});

	// サークルのジャンル 小ジャンルの開閉メニュー
	$('.js-search_toggle_btn').each(function() {
		$(this).on('click', function() {
			$(this).next().toggleClass('s-open');
			$(this).toggleClass('on');
			return false;
		});
	});

	$('.js-search_parentbtn').change(function(){
		if ($(this).prop("checked")) {
		  // チェックがはいっている
		  console.log('はいってる');
		} else {
		  // チェックがはいっていない
		  console.log('はいってない');
		}
		// console.log($(this).attr('class'));
		if($(this).parent('.checkbox__item').hasClass('s-active')) {
			$(this).siblings('.checkbox__parente_name').remove();
			$(this).prop('checked', true);
		} else if (!$(this).prop("checked")) {
			// console.log('はいってない');
			return false;
		} else {
			console.log('はいってる');
			// labelとは別に、選択中の科目を表示するための要素を作る
			let label = $(this).siblings('label').text();
			$(this).before('<div class="checkbox__parente_name">' + label + '</div>');
			// 親を選択したら、子供はすべて選択済みにする
			$(this).siblings('.checkbox__grp--child').find('input[type="checkbox"]').prop('checked', true);
		}
		$(this).parent('.checkbox__item').siblings('.checkbox__item').toggleClass('s-hidden');
		$(this).parent('.checkbox__item').toggleClass('s-active');
		$(this).siblings('.checkbox__grp--child').find('.checkbox__item').toggleClass('s-open');
		$(this).siblings('.checkbox__grp--child').toggleClass('s-open');
	});

	// サークルのジャンルの親子制御
	// 親にチェックを入れたら子供すべてにチェックを入れる
	// 子供のチェックが一つでも外れたら親のチェックを外す
	$('.checkbox__item input').change(function() {
		console.log('change');

		if ($(this).is(':checked')) {
			console.log('checkされている');
			$(this).parent().find("input:checkbox").prop('checked', true);

			// こどものチェックが0の場合、親のチェックも外す
			console.log($(this).parent('.checkbox__item').siblings('.checkbox__item').find('input:checkbox:checked').length);
			console.log($(this).parent('.checkbox__item').siblings('.checkbox__item').find('input:checkbox').length);
			if($(this).parent('.checkbox__item').siblings('.checkbox__item').find('input:checkbox:checked').length == $(this).parent('.checkbox__item').siblings('.checkbox__item').find('input:checkbox').length) {
				console.log('childのチェックは全部');
				$(this).parents('.checkbox__item--haschild').find('input:checkbox').prop('checked', true);
			}
		} else {
			console.log('checkされていない');
			$(this).parent().find("input:checkbox").prop('checked', false);
			$(this).parents('li').each(function(){
				$(this).children('input:checkbox').prop('checked', false);
			});
		}
	});

	$('.tabpanel__item').hide();
	$('.tabpanel__item').first().slideDown();
	$('.tab_btns__item').on('click', function() {
		var thisclass = $(this).attr('data-tabcont');
		$('.lamp').removeClass().addClass('lamp').addClass(thisclass);
		$('.tabpanel__item').each(function() {
			if($(this).attr('data-tabcont') == thisclass){
				$(this).fadeIn(800);
			}
			else{
				$(this).hide();
			}
		});
	});

	// 総合評価の星の点数（5段階、小数点）を百分率へ変換してwidthに上書き
	if($('.starbox__rate_active').length) {
		$('.starbox__rate_active').each(function() {
			let point = $(this).attr('data-star-point') / 5;
			// console.log(point);
			let percentage = Math.round(point * 100) / 100;
			// console.log(percentage);
			$(this).css('width', percentage * 100 + '%');
		});
	}

});

